import { Grid } from '@mui/material';
import { ReactNode } from 'react';

export const EventItemRow = ({ children }: { children: ReactNode }) => {
  return (
    <Grid container alignItems="center" sx={{ gap: '12px', flexWrap: 'nowrap' }}>
      {children}
    </Grid>
  );
};
